import throttle from 'lodash/throttle'

export default {
  computed: {
    annotateFrom: function () {
      return this.annotateKey ? this._get(this.annotateKey, null) : null
    }
  },

  watch: {
    annotateFrom: function (attachment) {
      if (attachment) {
        this.makeAnnotationFrom(attachment)
      }
    }
  },

  methods: {
    makeAnnotationFrom: throttle(function (attachment) {
      this.seenText = true
      this.focusInput = true

      const next = () => {
        this._delete(this.annotateKey)
        this.$nextTick(() => {
          this.scrollIntoView()
          this.editAttachment(this.attachments.length - 1, this.cancelContribution, true)
        })
      }

      if (attachment.type === 'whiteboard') {
        let id = 0
        let dispatch = ''
        if (attachment.commentID) {
          id = attachment.commentID
          dispatch = 'copyCommentAttachment'
        } else {
          id = attachment.postID
          dispatch = 'copyPostAttachment'
        }

        this.$store.dispatch(dispatch, { id, attachment }).then((storageKey) => {
          this.attachments.push({
            type: 'whiteboard',
            key: storageKey,
            metadata: { uuid: this.currentUser.uuid },
            parentID: attachment.id
          })
          next()
        })
      } else if (attachment.type === 'image') {
        this.attachments.push({
          type: 'image',
          url: attachment.url,
          parentID: attachment.id
        })
        next()
      }
    }, 500, { leading: true, trailing: false }),

    cancelContribution: function () {
      if (this.attachments.length > 0) {
        this.attachments.pop()
      }
    },

    editAttachment: function (position, cancelCallback, annotate) {
      if (this.attachments[position]) {
        this.$refs.attachments.editAttachment(position, cancelCallback, annotate)
      }
    }
  }
}
